import dayjs from 'dayjs';

import { generalReportMetrics, providerScheduleMetrics } from '../data';

const formatDate = value => dayjs(value).format('DD.MM.YYYY');

export const getFilterPeriodLabel = (params, locale) => {
  if (params.quick_period && locale[params.quick_period]) {
    return locale[params.quick_period];
  }

  if (params.date_from && params.date_to) {
    return `${formatDate(params.date_from)} - ${formatDate(params.date_to)}`;
  }

  return locale.periodNotSpecified;
};

export const getFilterMetricsLabels = (params, locale) => {
  const labels = [];

  const mainMetric = generalReportMetrics.find(item => item.key === params.metric);
  if (mainMetric) {
    labels.push(locale[mainMetric.label] || mainMetric.key);
  }

  (params.provider_metrics || []).forEach(metricKey => {
    const config = providerScheduleMetrics.find(item => item.key === metricKey);
    if (config) {
      labels.push(locale[config.label] || metricKey);
    }
  });

  return labels;
};

export const buildSavedFilterLabels = (params, locale) => {
  const metrics = getFilterMetricsLabels(params, locale);
  const period = getFilterPeriodLabel(params, locale);
  const name = metrics.length ? `${metrics.join(', ')} · ${period}` : period;

  const descriptionParts = [];

  if (params.date_from && params.date_to) {
    descriptionParts.push(
      `${locale.from} ${formatDate(params.date_from)} - ${locale.to.toLowerCase()} ${formatDate(params.date_to)}`,
    );
  }

  if (params.compare?.enabled && params.compare.date_from && params.compare.date_to) {
    descriptionParts.push(
      `${locale.compare}: ${formatDate(params.compare.date_from)} - ${formatDate(params.compare.date_to)}`,
    );
  }

  if (params.providers?.length) {
    descriptionParts.push(params.providers[0]);
  }

  return {
    name,
    description: descriptionParts.length ? descriptionParts.join(' · ') : null,
  };
};
